import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddEventDiscount from "./AddEventDiscount";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import { toast } from "react-toastify";
import HelperService from "../../utility/HelperService";
const columns = [
  {
    id: "applyOn",
    label: "Discount On",
    minWidth: 130,
  },
  {
    id: "applyName",
    label: "Name",
    minWidth: 170,
  },
  {
    id: "discountCode",
    label: "Coupon Code",
    minWidth: 150,
    // sortable: true,
  },
  {
    id: "mode",
    label: "Type",
    minWidth: 120,
    // sortable: true,
  },
  {
    id: "amount",
    label: "Amount",
    minWidth: 100,
    // sortable: true,
  },
  // {
  //   id: "usageCount",
  //   label: "Used / Max",
  //   minWidth: 120,
  //   align: "center" as const,
  // },
  {
    id: "startDate",
    label: "Start Date",
    minWidth: 120,
    sortable: true,
  },
  {
    id: "endDate",
    label: "End Date",
    minWidth: 120,
    sortable: true,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as const,
  },
];

const IndustryReport = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] = useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<any | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const [applyOnFilter, setApplyOnFilter] = useState("");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);

  // ✅ All params as refs — never stale inside getDiscounts
  const searchRef = useRef<string>("");
  const applyOnRef = useRef<string>("");
  const sortFieldRef = useRef<string>("createdAt");
  const sortOrderRef = useRef<"asc" | "desc">("desc");

  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    name: "name",
    type: "type",
    createdAt: "createdAt",
    startDate: "startDate",
    endDate: "endDate",
  };

  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });

  // ✅ Only runs on mount — no stale closure risk
  useEffect(() => {
    getDiscounts(searchRef.current, applyOnRef.current, sortFieldRef.current, sortOrderRef.current, 1);
  }, []);

  const getDiscounts = (
    keyword: string = "",
    applyOn: string = "",
    currentSortField: string = "createdAt",
    currentSortOrder: "asc" | "desc" = "desc",
    page: number = 1,
  ) => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("limit", itemsPerPage.toString());
    if (keyword.trim()) params.append("keyword", keyword.trim());
    if (applyOn) params.append("applyOn", applyOn);
    params.append("sortField", currentSortField);
    params.append("sortOrder", currentSortOrder);

    console.log("API Call =>", `discount/getList?${params.toString()}`); // ← debug

    WebService.getAPI({ action: `discount/getList?${params.toString()}` })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        if (!res?.data?.data) return;

        const formattedRows = res.data.data.map((item: any) => {
          const applyIdObj = item.applyId;
          const applyName = applyIdObj?.title || applyIdObj?.planName || applyIdObj?.name || "-";
          return {
            ...item,
            applyOn: HelperService.getDiscountApplyOnLabel(item.applyOn),
            applyName,
            amount: item.mode === "PERCENTAGE" ? `${item.amount}%` : `₹${item.amount}`,
            mode: item.mode?.charAt(0).toUpperCase() + item.mode?.slice(1).toLowerCase(),
            usageCount: item.maxUse != null ? `${item.usedCount ?? 0} / ${item.maxUse}` : `${item.usedCount ?? 0} / ∞`,
            startDate: HelperService.dateFormatter(item.startDate),
            endDate: HelperService.dateFormatter(item.endDate),
            action: (
              <div>
                {perm.canEdit && (
                  <PencilFill className="me-3 cursor-pointer"
                    onClick={() => { setShowAddLeadershipCouncil(true); setLeadershipCouncilToEdit(item); }}
                    title="Edit"
                  />
                )}
                {perm.canDelete && (
                  <TrashFill color="#DC143C" className="cursor-pointer"
                    onClick={() => handleDeleteEvent(item._id)}
                    title="Delete"
                  />
                )}
              </div>
            ),
          };
        });

        console.log("Response page =>", res.data.pagination); // ← debug
        setLeadershipCouncils(formattedRows);
        setTotalCount(res.data.pagination.total || 0);
      })
      .catch((err: any) => console.error("Error fetching discounts:", err))
      .finally(() => setLoading(false));
  };

  const handleDeleteEvent = (id: string) => {
    setLeadershipCouncilToDelete(id);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddEventDiscount
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getDiscounts(searchRef.current, applyOnRef.current, sortFieldRef.current, sortOrderRef.current, currentPage);
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({ action: `discount/deleteContent/${leadershipCouncilToDelete}` })
              .then(() => {
                toast.success("Discount coupon deleted successfully");
                setShowDeleteModal(false);
                getDiscounts(searchRef.current, applyOnRef.current, sortFieldRef.current, sortOrderRef.current, 1);
                setCurrentPage(1);
              })
              .catch((err: any) => toast.error(err?.response?.data?.message || "Failed to delete coupon"));
          }
        }}
        message="Are you sure you want to delete this discount coupon?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Coupon Code</div>
            {pagePermission.canAdd && (
              <CustomButton isLoading={false} label="Add"
                onClick={() => { setLeadershipCouncilToEdit(null); setShowAddLeadershipCouncil(true); }}
                style={{ width: 100 }}
              />
            )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control type="text" placeholder="Enter amount, code or mode" value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;
                  setSearch(value);
                  setCurrentPage(1);
                  getDiscounts(value, applyOnRef.current, sortFieldRef.current, sortOrderRef.current, 1);
                }}
              />
            </div>
            <div className="col-md-3">
              <Form.Label className="label">Discount On</Form.Label>
              <Form.Select value={applyOnFilter}
                onChange={(e) => {
                  const value = e.target.value;
                  applyOnRef.current = value;
                  setApplyOnFilter(value);
                  setCurrentPage(1);
                  getDiscounts(searchRef.current, value, sortFieldRef.current, sortOrderRef.current, 1);
                }}
              >
                <option value="">All</option>
                <option value="EVENT">Event</option>
                <option value="PLAN">Membership</option>
                <option value="REPORT">Industry Report</option>
              </Form.Select>
            </div>
          </div>
          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
              // ✅ Call directly with explicit page — no stale state
              getDiscounts(searchRef.current, applyOnRef.current, sortFieldRef.current, sortOrderRef.current, page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              sortFieldRef.current = apiField;   // ✅ sync ref immediately
              sortOrderRef.current = order;       // ✅ sync ref immediately
              setCurrentPage(1);
              getDiscounts(searchRef.current, applyOnRef.current, apiField, order, 1);
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default IndustryReport;
